import { useQuery } from '@tanstack/react-query'
import { rqKeys } from '@/react-query-keys'
import { apiRequestNew } from '@/helpers/request'
import { getMs } from '@/helpers'
import type { T_DocsResponse } from '@/types/responses'

export const useBecome = (docName?: string) => {
  const { data, isLoading } = useQuery<T_DocsResponse>({
    queryKey: [ rqKeys.becoms, docName ],
    queryFn: () =>
      apiRequestNew(
        'GET',
        docName
          ? `/portal/article?path=become&name=${docName}&fields=name,title,content`
          : '/portal/article?path=become'
      ),
    enabled: docName !== undefined ? !!docName : true,
    staleTime: getMs('15m'),
    refetchOnWindowFocus: false,
  })

  return { data, isLoading }
}
